const calculateTotalTime = (hours, minutes) => {
    const decimalHours = parseFloat(hours || '0');
    const decimalMinutes = parseFloat(minutes || '0') / 100;
    return decimalHours + decimalMinutes;
};

const validateTime = (TotalHours, TotalMinutes, billableHours, billableMinutes, nonBillableHours, nonBillableMinutes) => {
    const timeSpentTotal = calculateTotalTime(TotalHours, TotalMinutes);
    const billableTotal = calculateTotalTime(billableHours, billableMinutes);
    const nonBillableTotal = calculateTotalTime(nonBillableHours, nonBillableMinutes);

    const checkSum = timeSpentTotal - (billableTotal + nonBillableTotal);
    
    let time_spend = timeSpentTotal;
    if(checkSum === 0.010000000000000009 || checkSum === 0.009999999999999787 ){
        time_spend = time_spend - 0.01;
    }

    if(checkSum === -0.010000000000000009 || checkSum === -0.009999999999999787 ){
        time_spend = time_spend + 0.01;
    }

    return time_spend === (billableTotal + nonBillableTotal);
};



const convertTimeToDecimal = (timeStr) => {
    if (!timeStr || timeStr === "") return 0;
    const [hours, minutes] = timeStr.split(':').map(Number);
    return parseFloat(hours) + (parseFloat(minutes || '0') / 100);
};



export { calculateTotalTime, validateTime, convertTimeToDecimal};